import { createContext, useContext, useEffect, useState } from "react";
import { signInWithEmailAndPassword, onAuthStateChanged, signOut } from "firebase/auth";
import { auth } from "../firebase-config";
import { getDatabase, ref, push } from "firebase/database"; //deepa audit logs

const UserAuthContext = createContext();

export const UserAuthContextProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [role, setRole] = useState(localStorage.getItem("role") || "");
  const [loading, setLoading] = useState(true); // Introduce loading state

  async function logIn(email, password) {
    setLoading(true); // Ensure loading is true when starting login
    const res = await signInWithEmailAndPassword(auth, email, password);
    setUser(res.user);
    setRole(localStorage.getItem("role") || "")
    // After login, you should set the role based on user details or keep it from localStorage
    setLoading(false); // Set loading to false after login process is complete
    return res;
  }

  // Function to log user logout events //deepa audit logs
  const logUserLogout = async (userData, context = {}) => {
    try {
      const db = getDatabase();
      const logRef = ref(db, "audit_logs/Authentication/User_Logout");
      
      // Add user agent info if available
      if (typeof window !== 'undefined') {
        context.user_agent = navigator.userAgent;
      }
      
      // Get user location using IP geolocation API
      try {
        const response = await fetch('https://ipapi.co/json/');
        const locationData = await response.json();
        
        // Add location data to context
        context.location = {
          city: locationData.city || 'Unknown',
          region: locationData.region || 'Unknown',
          country: locationData.country_name || 'Unknown',
          ip: locationData.ip || 'Unknown'
        };
      } catch (locationError) {
        console.error("Error fetching location data:", locationError);
        context.location = { error: "Location data unavailable" };
      }
      
      push(logRef, {
        timestamp: new Date().toISOString(),
        user: userData,
        outcome: "success",
        context: context
      });
    } catch (error) {
      console.error("Error logging user logout:", error);
    }
  };

  function logOut() {
    // Store current user information before logout for audit logs
    const currentRole = localStorage.getItem("role") || "";
    
    // Get the correct username based on role
    let userName = "Unknown User";
    let userEmail = user?.email || localStorage.getItem("senderEmail") || "";
    
    if (currentRole === "doctor") {
      userName = localStorage.getItem("docName") || "Unknown Doctor";
      userEmail = localStorage.getItem("docEmail") || userEmail;
    } else if (currentRole === "technician") {
      userName = localStorage.getItem("techName") || "Unknown Technician";
    } else if (currentRole === "admin") {
      userName = localStorage.getItem("adminName") || "Unknown Admin";
    } else if (currentRole === "superadmin") {
      userName = "Super Admin";
    }
    
    // Log the logout event with correct user information
    logUserLogout(
      {
        username: userName,
        email: userEmail,
        // roles: currentRole
      },
      { ip_address: "client-ip" }
    );

    // Sign out, then clear all of our user-specific localStorage keys
    return signOut(auth).then(() => {
      setUser(null);
      setRole("");
      // Clear all user-related localStorage items
      [
        "role",
        "adminName",
        "docName",
        "techName",
        "senderEmail",
        "docEmail",
        "adminEmail",
        "patientsList",
        "Name"
      ].forEach((key) => localStorage.removeItem(key));
      setLoading(false);
    });
  }
  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (currentUser) => {
      setUser(currentUser);
      setLoading(false); // Set loading to false once we receive the auth state
    });

    return () => unsubscribe();
  }, []);

  return (
    <UserAuthContext.Provider value={{ user, role, setRole, logIn, logOut, loading }}>
      {children}
    </UserAuthContext.Provider>
  );
};

export const useUserAuth = () => useContext(UserAuthContext);
